import { ComponentPropsWithoutRef } from 'react';
import { cn } from '@/shared/lib/cn';
import { Badge } from '@/shared/ui/badge';
import { Icon } from '@/shared/ui/icon';
import './time-badge.scss';

const TIME_THRESHOLD_LONG = 15;
const TIME_THRESHOLD_LONGEST = 30;

type Props = Omit<ComponentPropsWithoutRef<typeof Badge>, 'children'> & {
    time: number;
};
export const TimeBadge = ({ time, className, ...props }: Props) => {
    return (
        <Badge
            {...props}
            variant={
                time > TIME_THRESHOLD_LONGEST
                    ? 'error'
                    : time > TIME_THRESHOLD_LONG
                      ? 'darkWarning'
                      : 'success'
            }
            className={cn('time-badge', className)}
        >
            <Icon name="clock" />
            {time} min.
        </Badge>
    );
};
